// Node Modules
import React from "react";
// Testing a fake comment
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import renderHTML from "react-render-html";

// Global Components
import Image from "components/image/image";

// Local Components
import DashedLineBreak from "../components/dashedLineBreak/dashedLineBreak.js";

// Local Styling
import "./aboutUs.css";

// Local Assets
import AboutUsGif from "./assets/AboutUS_minimized.gif";
import TingImage from "./assets/ting-min.JPG";
import LuzImage from "./assets/luz-min.jpg";

// Local Components
class AboutUs extends React.Component {
  render() {
    return (
      <div className="content bio">
        <Image src={AboutUsGif} style={{ width: "100% !important" }} />
        <DashedLineBreak />
        <div className="columns">
          <div className="leftColumnHecha">
            <p>HECHA: (Spanish) fem. adj. </p>
            <p>1. made</p>
            <p>2. created</p>
            <p>3. turned into</p>
            <p>4. ready</p>
          </div>
          <div className="rightColumnZuo">
            <p>做: (Mandarin): zuò</p>
            <p>1. to do</p>
            <p>2. to make: to produce</p>
            <p>3. to become</p>
            <p>4. (euphemistic) to make love</p>
          </div>
        </div>
        <DashedLineBreak />
        <div className="bioDescription" style={{ textAlign: "center" }}>
          {renderHTML(documentToHtmlString(this.props.content))}
        </div>
        <br />
        <br />
        <div className="performers">
          <Image src={LuzImage} class="performer" />
          <h2>Luz Angélica Fernández</h2>
          <p>
            <a href="http://luzangelicafernandez.com/">
              Luz Angélica Fernández
            </a>{" "}
            is a multidisciplinary artist and native New Yorker whose work
            bridges the intersections between art, design, and technology. As a
            co-founder of HECHA / 做, Fernández focuses in the design and
            production management of the brand, as well as paints the fabric
            used for the main line garments. The aesthetic Fernández has
            developed for the fabric is derivative of her action painting
            practice and inspired by the patterns and textures of materials in
            natural and artificial settings such as snow, sand, clay, plaster,
            tar, and wet cement.
          </p>
          <p>
            In her personal body of work, Fernández’s paintings draw on both the
            origins of abstract expressionism and the semiotics of the internet
            age, the titles of which often evoke the social-media informed modes
            of communication now commonplace in everyday life. Having always
            lived in cities (other than her time at Hampshire College) and
            working in underground NYC nightlife for the past five years, her
            abstractions examine urban transition– recounting impressions of
            construction sites, decaying train stations, graffiti, repurposed
            warehouses, and neon-lit environments. She incorporates lighting
            from the back in some of her pieces, separating her restrained, bold
            strokes into sculptural entities hanging on the picture plane. Her
            contemplative mark-making reflects the physical residue of the
            passage of time in a post-industrial city. Through her works
            Fernández channels memory and emotion by creating metaphor and
            building textural color worlds from her immediate experiences.
          </p>
          <Image src={TingImage} class="performer" />
          <h2>Ting Ding</h2>
          <p>
            Ting Ding is a Chinese-Canadian statistical analyst, photographer,
            and visual designer. As a co-founder of HECHA / 做, Ding’s work
            considers the material composition of fashion production as well as
            the marketing and commercialization of the brand. She attended the
            University of Toronto where she studied Business and Economics
            (2010). At her hyper-capitalist day job at the language learning app
            Babbel, Ding collects, interprets and summarizes numerical data into
            useable, salable business drivers. Her analysis of the impact of
            changing market circumstances influences her artistic endeavors in
            the form of a self-designed “empathy-driven” business model, focused
            on sustainability and the restandardization of industry standards.
            Ding has also provided visual work in collaboration with composer
            Kepla and rhythmanalyst DeForrest Brown, Jr. for their mixtape “The
            Wages of Being Black is Death” and their performance at the XXII
            Triennale di Milano.
          </p>
        </div>
      </div>
    );
  }
}
export default AboutUs;
